import { useEffect } from "react";
import useUser from "../UserProvider/useUser";



const cookieName = "ulty-feature-variant";


export function useFeatureVariantCookie() {
  const { activeVariant,user } = useUser();
  useEffect(() => {
      if(user?.id){
        setVariantCookie(activeVariant);
      }
  }, [activeVariant,user?.id]);
}

export function setVariantCookie(variant) {
 if(variant){
      const cookieValue = variant;
      if(document.cookie?.includes(`${cookieName}=${cookieValue}`)) return;
      const maxAgeDays = 2;
      const expires = new Date(Date.now() + maxAgeDays * 864e5).toUTCString();
      document.cookie = `${cookieName}=${cookieValue}; path=/; expires=${expires}; SameSite=Lax`;
      // window.location.reload();

    } else {
        clearVariantCookie();
    }
}

export function clearVariantCookie() {
    if(document.cookie.includes(cookieName)){
        document.cookie = `${cookieName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        // window.location.reload();
    }
}
